<template>
  <footer>
    <p class="logo">DOLAS</p>
    <div class="parent">
      <div class="div1"><p>Follow us</p></div>
      <div class="div2">
        <router-link to="/404">
          <store-button
            :padding="'4px 12px'"
            :height="'30px'"
            :fontSize="'1.8rem'"
            :width="'16rem'"
            >Instagram</store-button
          >
        </router-link>
      </div>
      <div class="div3">
        <router-link to="/404">
          <store-button
            :padding="'4px 12px'"
            :height="'30px'"
            :fontSize="'1.8rem'"
            :width="'16rem'"
            >Twitter</store-button
          >
        </router-link>
      </div>
      <div class="div4">
        <router-link to="/404">
          <store-button
            :padding="'4px 12px'"
            :height="'30px'"
            :fontSize="'1.8rem'"
            :width="'16rem'"
            >Facebook</store-button
          >
        </router-link>
      </div>
      <div class="div5"><router-link to="/404">About</router-link></div>
      <div class="div6"><router-link to="/404">Contact Us</router-link></div>
      <div class="div7">
        <router-link to="/404">Customer service</router-link>
      </div>
      <div class="div8"><router-link to="/404">Payment</router-link></div>
      <div class="div9">
        <router-link to="/404">Shipping and returns</router-link>
      </div>
      <div class="div10"><router-link to="/404">Discounts</router-link></div>
      <div class="div11">
        <router-link :to="{ name: 'Tshirts' }">T-Shirts</router-link>
      </div>
      <div class="div12">
        <router-link :to="{ name: 'Hoodies' }">Hoodies</router-link>
      </div>
      <div class="div13">
        <router-link :to="{ name: 'Pants' }">Pants</router-link>
      </div>
      <div class="div14">
        <router-link :to="{ name: 'Sweatshirts' }">Sweatshirts</router-link>
      </div>
      <div class="div15">
        <router-link :to="{ name: 'Coats' }">Coats</router-link>
      </div>
      <div class="div16"><router-link to="/404">Help</router-link></div>
      <div class="div17">
        <router-link to="/404">Privacy policy</router-link>
      </div>
      <div class="div18">
        <router-link to="/404">Terms and conditions</router-link>
      </div>
      <div class="div19">
        <router-link to="/404">Copryright information</router-link>
      </div>
      <div class="div20"><router-link to="/404">Partnership</router-link></div>
    </div>
  </footer>
</template>


<style scoped>
footer {
  background: rgba(0, 0, 0, 0.9);
  padding: 30px 40px;
  height: auto;
}

.logo {
  color: #fff;
  font-family: "Glusp";
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 45px;
}

.parent {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(6, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 20px;
}

div > :is(a, p) {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 500;
}

.div1 {
  grid-area: 1 / 1 / 2 / 2;
}
.div2 {
  grid-area: 2 / 1 / 3 / 2;
}
.div3 {
  grid-area: 3 / 1 / 4 / 2;
}
.div4 {
  grid-area: 4 / 1 / 5 / 2;
}
.div5 {
  grid-area: 1 / 2 / 2 / 3;
}
.div6 {
  grid-area: 2 / 2 / 3 / 3;
}
.div7 {
  grid-area: 3 / 2 / 4 / 3;
}
.div8 {
  grid-area: 4 / 2 / 5 / 3;
}
.div9 {
  grid-area: 5 / 2 / 6 / 3;
}
.div10 {
  grid-area: 6 / 2 / 7 / 3;
}
.div11 {
  grid-area: 1 / 3 / 2 / 4;
}
.div12 {
  grid-area: 2 / 3 / 3 / 4;
}
.div13 {
  grid-area: 3 / 3 / 4 / 4;
}
.div14 {
  grid-area: 4 / 3 / 5 / 4;
}
.div15 {
  grid-area: 5 / 3 / 6 / 4;
}
.div16 {
  grid-area: 1 / 4 / 2 / 5;
}
.div17 {
  grid-area: 2 / 4 / 3 / 5;
}
.div18 {
  grid-area: 3 / 4 / 4 / 5;
}
.div19 {
  grid-area: 4 / 4 / 5 / 5;
}
.div20 {
  grid-area: 5 / 4 / 6 / 5;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  /* стили для мобильных устройств */
  .parent {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(20, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 20px;
  }

  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .div3 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .div4 {
    grid-area: 4 / 1 / 5 / 2;
  }
  .div5 {
    grid-area: 5 / 1 / 6 / 2;
  }
  .div6 {
    grid-area: 6 / 1 / 7 / 2;
  }
  .div7 {
    grid-area: 7 / 1 / 8 / 2;
  }
  .div8 {
    grid-area: 8 / 1 / 9 / 2;
  }
  .div9 {
    grid-area: 9 / 1 / 10 / 2;
  }
  .div10 {
    grid-area: 10 / 1 / 11 / 2;
  }
  .div11 {
    grid-area: 11 / 1 / 12 / 2;
  }
  .div12 {
    grid-area: 12 / 1 / 13 / 2;
  }
  .div13 {
    grid-area: 13 / 1 / 14 / 2;
  }
  .div14 {
    grid-area: 14 / 1 / 15 / 2;
  }
  .div15 {
    grid-area: 15 / 1 / 16 / 2;
  }
  .div16 {
    grid-area: 16 / 1 / 17 / 2;
  }
  .div17 {
    grid-area: 17 / 1 / 18 / 2;
  }
  .div18 {
    grid-area: 18 / 1 / 19 / 2;
  }
  .div19 {
    grid-area: 19 / 1 / 20 / 2;
  }
  .div20 {
    grid-area: 20 / 1 / 21 / 2;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  /* стили для планшетов */
  .parent {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(20, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 20px;
  }

  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .div3 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .div4 {
    grid-area: 4 / 1 / 5 / 2;
  }
  .div5 {
    grid-area: 5 / 1 / 6 / 2;
  }
  .div6 {
    grid-area: 6 / 1 / 7 / 2;
  }
  .div7 {
    grid-area: 7 / 1 / 8 / 2;
  }
  .div8 {
    grid-area: 8 / 1 / 9 / 2;
  }
  .div9 {
    grid-area: 9 / 1 / 10 / 2;
  }
  .div10 {
    grid-area: 10 / 1 / 11 / 2;
  }
  .div11 {
    grid-area: 11 / 1 / 12 / 2;
  }
  .div12 {
    grid-area: 12 / 1 / 13 / 2;
  }
  .div13 {
    grid-area: 13 / 1 / 14 / 2;
  }
  .div14 {
    grid-area: 14 / 1 / 15 / 2;
  }
  .div15 {
    grid-area: 15 / 1 / 16 / 2;
  }
  .div16 {
    grid-area: 16 / 1 / 17 / 2;
  }
  .div17 {
    grid-area: 17 / 1 / 18 / 2;
  }
  .div18 {
    grid-area: 18 / 1 / 19 / 2;
  }
  .div19 {
    grid-area: 19 / 1 / 20 / 2;
  }
  .div20 {
    grid-area: 20 / 1 / 21 / 2;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  /* стили для ноутбуков */
  .parent {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 20px;
  }

  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .div3 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .div4 {
    grid-area: 4 / 1 / 5 / 2;
  }
  .div5 {
    grid-area: 5 / 1 / 6 / 2;
  }
  .div6 {
    grid-area: 6 / 1 / 7 / 2;
  }
  .div7 {
    grid-area: 7 / 1 / 8 / 2;
  }
  .div8 {
    grid-area: 8 / 1 / 9 / 2;
  }
  .div9 {
    grid-area: 9 / 1 / 10 / 2;
  }
  .div10 {
    grid-area: 10 / 1 / 11 / 2;
  }
  .div11 {
    grid-area: 1 / 2 / 2 / 3;
  }
  .div12 {
    grid-area: 2 / 2 / 3 / 3;
  }
  .div13 {
    grid-area: 3 / 2 / 4 / 3;
  }
  .div14 {
    grid-area: 4 / 2 / 5 / 3;
  }
  .div15 {
    grid-area: 5 / 2 / 6 / 3;
  }
  .div16 {
    grid-area: 6 / 2 / 7 / 3;
  }
  .div17 {
    grid-area: 7 / 2 / 8 / 3;
  }
  .div18 {
    grid-area: 8 / 2 / 9 / 3;
  }
  .div19 {
    grid-area: 9 / 2 / 10 / 3;
  }
  .div20 {
    grid-area: 10 / 2 / 11 / 3;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  /* стили для десктопов */
  .parent {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 20px;
  }

  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .div3 {
    grid-area: 3 / 1 / 4 / 2;
  }
  .div4 {
    grid-area: 4 / 1 / 5 / 2;
  }
  .div5 {
    grid-area: 5 / 1 / 6 / 2;
  }
  .div6 {
    grid-area: 6 / 1 / 7 / 2;
  }
  .div7 {
    grid-area: 7 / 1 / 8 / 2;
  }
  .div8 {
    grid-area: 8 / 1 / 9 / 2;
  }
  .div9 {
    grid-area: 9 / 1 / 10 / 2;
  }
  .div10 {
    grid-area: 10 / 1 / 11 / 2;
  }
  .div11 {
    grid-area: 1 / 2 / 2 / 3;
  }
  .div12 {
    grid-area: 2 / 2 / 3 / 3;
  }
  .div13 {
    grid-area: 3 / 2 / 4 / 3;
  }
  .div14 {
    grid-area: 4 / 2 / 5 / 3;
  }
  .div15 {
    grid-area: 5 / 2 / 6 / 3;
  }
  .div16 {
    grid-area: 6 / 2 / 7 / 3;
  }
  .div17 {
    grid-area: 7 / 2 / 8 / 3;
  }
  .div18 {
    grid-area: 8 / 2 / 9 / 3;
  }
  .div19 {
    grid-area: 9 / 2 / 10 / 3;
  }
  .div20 {
    grid-area: 10 / 2 / 11 / 3;
  }
}
</style>